import { NotFoundPage } from "../../../../pages/NotFound";
import { appRouterPaths } from "../../../../services/navigation/urls";
import type { AppRouteProps } from "../../types";

export const notFoundPageRouteConfig: AppRouteProps = {
  path: appRouterPaths.notFound.root,
  element: <NotFoundPage />,
  name: "Страница не найдена",
};
